export default "__VITE_ASSET__DSwfqiRq__"